import ErrorScreen from '../../../../common/components/organisme/ErrorScreen/ErrorScreen'
import useQueryURL from '../../../../common/hooks/useQueryURL'
import useNavigationApp from '../../../../navigation/useNavigationApp'
import SingleOrganization from '../../../organization/components/SingleOrganization'
import { useAuth } from '../../hooks'
import AuthFormView from './AuthFormView/AuthFormView'
import { useEffect, useState } from 'react'

export default function AuthFormPresenter({orgnizationId, withOrganization, linkToResetPassword}: {orgnizationId?: string, withOrganization?: boolean, linkToResetPassword?: string}) {
  const {

    isLoading,
    error,
    loginUser

  } = useAuth()

  const { getQueryValue } = useQueryURL()

  const orgnizationIdParams = getQueryValue("organizationId")
  const navigate = useNavigationApp()

  const organizationIdFound = orgnizationId || orgnizationIdParams


 
  const [password, setPassword] = useState<string>("")
  const [email, setEmail] = useState<string>("")
  const [errorMessage, setErrorMessage] = useState<string| undefined>(undefined)


  

  const resetform = () => {
    setPassword("")
    setEmail("")
    setErrorMessage(undefined)
  }

  const handleLogin = () => {
      setErrorMessage(undefined)
      loginUser({email: email , password : password})

  }
  useEffect(() => {
    if (!error) {
      setErrorMessage(undefined)
      return
    }
    const errorObject = error?.response?.data as any

    if (errorObject?.statusCode === 404) {
      setErrorMessage( 'Email ou mot de passe incorrect')
    }else{
      setErrorMessage("Une erreur est survenue")
    }

    return () => {
      resetform()
    }
  },[error])

  const onForgetPassword = () => {
    if (linkToResetPassword) {
      navigate.goTo(linkToResetPassword)
      return 
    }

    navigate.goToHome()

  }

  if (withOrganization && (!organizationIdFound || organizationIdFound === "")) {
    return <ErrorScreen title='Page de connexion introuvable' description="Veuillez vérifier l'url ou contacter votre organisation"/>
  }
  return <AuthFormView 
    isLoading={isLoading}
    messageError={errorMessage}
    setEmail={setEmail}
    setPassword={setPassword}
    handleSubmit={handleLogin}
    organizationRender={() =><SingleOrganization.Info id={organizationIdFound || undefined}  info='organization_name'/>}
    linkToResetPassword={linkToResetPassword}
   onClickForgetPassword={onForgetPassword}
  />
}
